<template>
  <tbody class="thead">
    <tr>
      <th v-if="walker.sub_show">
        {{ walker.sub_label }}
      </th>
      <th v-if="walker.third_show">
        {{ walker.third_label }}
      </th>
      <th>Start</th>
      <th>End</th>
      <th>Type</th>
      <th>Reason</th>
      <th>Approved by</th>
      <th>Changed by</th>
      <th>Duration</th>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeOffTransactionsReportTableHeader',
  computed: {
    ...mapGetters(['walker']),
  },
};
</script>
